import {TemplateSettingsModel} from "../../models/templates"
import {DEFAULT_TEMPLATE} from "../../config/constants"

export const SET_TEMPLATE = "SET_TEMPLATE"

interface SetTemplateAction {
    type: typeof SET_TEMPLATE
    mainTemplate: string
    fallbackTemplate: string
}

export interface TemplateSettingsDuckState {
    mainTemplate: string
    fallbackTemplate: string
}

export type TemplateSettingsStateModel = TemplateSettingsModel

export const initialTemplateState = {mainTemplate: DEFAULT_TEMPLATE, fallbackTemplate: DEFAULT_TEMPLATE}

export const setTemplateAction = (mainTemplate: string, fallbackTemplate: string): SetTemplateAction => {
    return {
        type: SET_TEMPLATE,
        mainTemplate,
        fallbackTemplate,
    }
}

const reducer = (state: TemplateSettingsStateModel = initialTemplateState, action: SetTemplateAction) => {
    switch (action.type) {
        case SET_TEMPLATE:
            return {mainTemplate: action.mainTemplate, fallbackTemplate: action.fallbackTemplate}
        default:
            return state
    }
}

export const updateTemplate = (store, templateConfig: TemplateSettingsModel) => {
    store.dispatch(setTemplateAction(templateConfig.mainTemplate, templateConfig.fallbackTemplate))
}

export default reducer
